export function ToRevenueExpense(revenueExpenseSummary: any, year: number) {
  const _revenueExpenseSummary = {
    year: year,
    totalRevenue: 0,
    totalExpense: 0,
    totalProfit: 0,
    changeFormType: 0,
    revenueChangeFormValue: 0,
    expenseChangeFormValue: 0,
    profitChangeFormValue: 0,
    revenueExpenseList: [] as any,
  };
  if (revenueExpenseSummary !== null) {
    for (const revenueAndExpense of revenueExpenseSummary.revenueAndExpenseList) {
      _revenueExpenseSummary.revenueExpenseList.push(revenueAndExpense);
    }
    _revenueExpenseSummary.totalRevenue = revenueExpenseSummary.totalRevenue;
    _revenueExpenseSummary.totalExpense = revenueExpenseSummary.totalExpense;
    _revenueExpenseSummary.totalProfit = revenueExpenseSummary.totalProfit;
    _revenueExpenseSummary.changeFormType = revenueExpenseSummary.changeFormType;
    _revenueExpenseSummary.revenueChangeFormValue = revenueExpenseSummary.revenueChangeFormValue;
    _revenueExpenseSummary.expenseChangeFormValue = revenueExpenseSummary.expenseChangeFormValue;
    _revenueExpenseSummary.profitChangeFormValue = revenueExpenseSummary.profitChangeFormValue;
  }
  return _revenueExpenseSummary;
}
export function ToSummaryInvoiceRemainPayment(_summaryRemainPayment: any) {
  const summaryInvoiceRemainPaymentList = {
    after2MonthRemainPayment: 0.0,
    lastMonthOverDue: 0.0,
    next2MonthRemainPayment: 0.0,
    nextMonthRemainPayment: 0.0,
    remainPayment: 0.0,
    thisMonthRemainPayment: 0.0,
    totalOverDue: 0.0,
    totalOverDueInvoice: 0,
    totalRemainPaymentInvoice: 0,
  };
  if (_summaryRemainPayment !== null) {
    (summaryInvoiceRemainPaymentList.after2MonthRemainPayment = _summaryRemainPayment.after2MonthRemainPayment),
      (summaryInvoiceRemainPaymentList.lastMonthOverDue = _summaryRemainPayment.lastMonthOverDue),
      (summaryInvoiceRemainPaymentList.next2MonthRemainPayment = _summaryRemainPayment.next2MonthRemainPayment),
      (summaryInvoiceRemainPaymentList.nextMonthRemainPayment = _summaryRemainPayment.nextMonthRemainPayment),
      (summaryInvoiceRemainPaymentList.remainPayment = _summaryRemainPayment.remainPayment),
      (summaryInvoiceRemainPaymentList.thisMonthRemainPayment = _summaryRemainPayment.thisMonthRemainPayment),
      (summaryInvoiceRemainPaymentList.totalOverDue = _summaryRemainPayment.totalOverDue),
      (summaryInvoiceRemainPaymentList.totalOverDueInvoice = _summaryRemainPayment.totalOverDueInvoice),
      (summaryInvoiceRemainPaymentList.totalRemainPaymentInvoice = _summaryRemainPayment.totalRemainPaymentInvoice);
  }
  return summaryInvoiceRemainPaymentList;
}
export function ToSummaryProduct(_summaryIncome: any) {
  const summaryProduct: any = {
    total: 0.0,
    summaryList: [] as any,
  };
  if (_summaryIncome !== null) {
    summaryProduct.total = _summaryIncome.totalProduct;
    summaryProduct.changeFormValue = _summaryIncome.changeFormValue;
    summaryProduct.changeFormType = _summaryIncome.changeFormType;
    _summaryIncome.productList.forEach((product: any) => {
      const productList = {
        name: product.name,
        id: product.productId,
        total: product.summaryTotal,
        changeFormType: product.changeFormType,
        changeFormValue: product.changeFormValue,
      };
      summaryProduct.summaryList.push(productList);
    });
  }

  return summaryProduct;
}
export function ToSummaryContact(_contactSummary: any) {
  const contactSummary: any = {
    total: 0.0,
    summaryList: [],
  };

  if (_contactSummary !== null) {
    contactSummary.total = _contactSummary.total;
    contactSummary.changeFormValue = _contactSummary.changeFormValue;
    contactSummary.changeFormType = _contactSummary.changeFormType;
    _contactSummary.contactSummaryList.forEach((item: any) => {
      const contactSummaryData = {
        total: item.total,
        id: item.contactId,
        contactBranchCode: item.contactBranchCode,
        name: item.contactFullName,
        changeFormValue: item.changeFormValue,
        changeFormType: item.changeFormType,
      };
      contactSummary.summaryList.push(contactSummaryData);
    });
  }

  return contactSummary;
}
export function ToSummaryAccount(_accountSummary: any) {
  const accountSummary: any = {
    total: 0.0,
    summaryList: [],
  };
  if (_accountSummary !== null) {
    accountSummary.total = _accountSummary.totalAccount;
    accountSummary.changeFormValue = _accountSummary.changeFormValue;
    accountSummary.changeFormType = _accountSummary.changeFormType;
    _accountSummary.accountList.forEach((item: any) => {
      const accountSummaryData = {
        total: item.summaryTotal,
        id: item.accountId,
        name: item.name,
        changeFormValue: item.changeFormValue,
        changeFormType: item.changeFormType,
      };
      accountSummary.summaryList.push(accountSummaryData);
    });
  }

  return accountSummary;
}
export function ToSummaryFinance(_financeSummary: any) {
  const financeSummary: any = {
    summaryList: [] as any,
    changeFormValue: 0,
    changeFormType: 0,
    total: 0.0,
  };
  if (_financeSummary !== null) {
    const summaryList: any = [];
    financeSummary.total = _financeSummary.total;
    financeSummary.changeFormValue = _financeSummary.changeFormValue;
    financeSummary.changeFormType = _financeSummary.changeFormType;
    _financeSummary.financeSummaryList.forEach((item: any) => {
      const financeSummary = {
        total: item.total,
        id: item.bankAccountId,
        name: item.fullName,
        changeFormValue: item.changeFormValue,
        changeFormType: item.changeFormType,
      };
      summaryList.push(financeSummary);
    });
    financeSummary.summaryList = summaryList;
  }
  return financeSummary;
}
export function ToInvoiceRemainPaymentSummary(_invoiceRemainPaymentSummary: any) {
  const invoiceRemainPaymentSummary = {
    invoiceRemainPaymentSummaryPeriodType: 0,
    overDueCount: 0,
    overDueTotal: 0.0,
    remainCount: 0,
    remainTotal: 0.0,
    paidCount: 0,
    paidTotal: 0.0,
    invoiceRemainPaymentSummaryList: [] as any,
  };

  if (_invoiceRemainPaymentSummary !== null) {
    invoiceRemainPaymentSummary.invoiceRemainPaymentSummaryPeriodType =
      _invoiceRemainPaymentSummary.invoiceRemainPaymentSummaryPeriodType;
    invoiceRemainPaymentSummary.overDueCount = _invoiceRemainPaymentSummary.overDueCount;
    invoiceRemainPaymentSummary.overDueTotal = _invoiceRemainPaymentSummary.overDueTotal;
    invoiceRemainPaymentSummary.remainCount = _invoiceRemainPaymentSummary.remainCount;
    invoiceRemainPaymentSummary.remainTotal = _invoiceRemainPaymentSummary.remainTotal;
    invoiceRemainPaymentSummary.paidCount = _invoiceRemainPaymentSummary.paidCount;
    invoiceRemainPaymentSummary.paidTotal = _invoiceRemainPaymentSummary.paidTotal;

    if (_invoiceRemainPaymentSummary.invoiceRemainPaymentSummaryList.length > 0) {
      _invoiceRemainPaymentSummary.invoiceRemainPaymentSummaryList.forEach((item: any) => {
        const invoiceRemainPaymentSummaryData = {
          invoiceDay: item.invoiceDay,
          invoiceMonth: item.invoiceMonth,
          invoiceYear: item.invoiceYear,
          overDueCount: item.overDueCount,
          overDueTotal: item.overDueTotal,
          remainCount: item.remainCount,
          remainTotal: item.remainTotal,
          paidCount: item.paidCount,
          paidTotal: item.paidTotal,
          overDueChangeValue: item.overDueChangeValue,
          remainChangeValue: item.remainChangeValue,
          paidTotalChangeValue: item.paidTotalChangeValue,
          changeFormType: item.changeFormType,
        };
        invoiceRemainPaymentSummary.invoiceRemainPaymentSummaryList.push(invoiceRemainPaymentSummaryData);
      });
    }
  }
  return invoiceRemainPaymentSummary;
}
export function ToSummaryContactDashboard(_summaryIncome: any) {
  const summaryProduct: any = {
    total: 0.0,
    summaryList: [],
  };
  if (_summaryIncome !== null) {
    summaryProduct.total = _summaryIncome.totalProduct;
    summaryProduct.changeFormValue = _summaryIncome.changeFormValue;
    summaryProduct.changeFormType = _summaryIncome.changeFormType;
    _summaryIncome.accountList.forEach((item: any) => {
      const productList = {
        name: item.name,
        id: item.accountId,
        total: item.summaryTotal,
        changeFormType: item.changeFormType,
        changeFormValue: item.changeFormValue,
      };
      summaryProduct.summaryList.push(productList);
    });
  }
  return summaryProduct;
}
